// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Content from '@/components/Content'
import Default from '@/components/Default'
import Print from '@/components/Print'
import SmartTable from 'vuejs-smart-table'
import JsonCSV from 'vue-json-csv'
import VTooltip from 'v-tooltip'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import moment from 'moment'
import $ from 'jquery'

import '@/assets/css/material-components-web.min.css'
import '@/assets/css/icon.css'
import '@/assets/css/style-default.css'
import '@/assets/css/style.css'
import 'font-awesome/css/font-awesome.min.css'
import { DateTime } from 'luxon'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(SmartTable)
Vue.use(VTooltip, { defaultClass: 'nc-tooltip' })
Vue.config.productionTip = false
Vue.component('Default-layout', Default)
Vue.component('Content-layout', Content)
Vue.component('Print-layout', Print)
Vue.component('downloadCsv', JsonCSV)

/* eslint-disable no-new */
var vm = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

window.vm = vm
window.$ = window.jQuery = require('jquery')

Vue.mixin({
	methods: {

		generarUrlFactura: function (
			numFactura,
			fechaFacturacion,
			tipoDTE,
			isFacturacionNetsuite = 0,
			pais = null,
			idTransaction = null
		) {
			const codigoPais = pais || (this.$store && this.$store.state && this.$store.state.pais ? this.$store.state.pais.code : null)
			let tipoDocumento = 33 // factura electronica con iva
			if (tipoDTE === 34) {
				tipoDocumento = 34 // factura exenta de iva
			}
			let anio = ''
			let mes = ''
			if (numFactura !== null && fechaFacturacion) {
				if (fechaFacturacion.includes('/')) {
					let fechaFactura = fechaFacturacion.split('/')
					anio = parseInt(fechaFactura[2])
					mes = parseInt(fechaFactura[1])
				} else {
					let fechaFactura = fechaFacturacion.split('-')
					mes = parseInt(fechaFactura[1])
					anio = parseInt(fechaFactura[0])
				}
				// if (fechaFactura.length === 3) {
				let rutNCLeasing = '76497459'
				console.log('isFacturacionNetsuite', isFacturacionNetsuite)
				console.log('pais', pais)
				if (isFacturacionNetsuite === 1) {
					rutNCLeasing = '76497459-K'
					if (pais === 3) {
						rutNCLeasing = '20602274021'
					}

					let auth = {
						headers: { 'Authorization': this.accessToken },
						responseType: 'blob'
					}
					this.axios.post(this.apiurl + 'apiNetsuite/transactionPrintPdfFacele', {
						rutCliente: rutNCLeasing,
						tipoDTE: tipoDTE,
						factura: numFactura,
						pais: codigoPais,
						transaccionId: idTransaction || 38,
						// con el ID Tr. y la fecha el back obtiene de COMFIAR la serie, tipo y número reales
						fechaFacturacion: fechaFacturacion
					}, auth).then(response => {
						const reader = new FileReader()
						reader.onload = () => {
							try {
								const json = JSON.parse(reader.result)
								if (json && json.data && json.data.pdf_base64) {
									let byteCharacters = atob(json.data.pdf_base64)
									// Handle double base64 encoding
									if (byteCharacters.indexOf('%PDF') !== 0) {
										byteCharacters = atob(byteCharacters)
									}
									const byteNumbers = new Array(byteCharacters.length)
									for (let i = 0; i < byteCharacters.length; i++) {
										byteNumbers[i] = byteCharacters.charCodeAt(i)
									}
									const byteArray = new Uint8Array(byteNumbers)
									const pdfBlob = new Blob([byteArray], { type: 'application/pdf' })
									const pdfUrl = window.URL.createObjectURL(pdfBlob)
									// window.open en callback asincrono es bloqueado como popup;
									// si el navegador lo bloquea, se fuerza la descarga con <a download>
									const pdfWin = window.open(pdfUrl, '_blank')
									if (!pdfWin) {
										const link = document.createElement('a')
										link.href = pdfUrl
										link.download = json.data.filename || ('Factura_' + numFactura + '.pdf')
										document.body.appendChild(link)
										link.click()
										document.body.removeChild(link)
									}
									return
								}
								if (json && json.message) {
									alert(json.message)
								}
							} catch (e) {
								// Response is binary PDF, open directly
								const url = window.URL.createObjectURL(response.data)
								const pdfWin = window.open(url, '_blank')
								if (!pdfWin) {
									const link = document.createElement('a')
									link.href = url
									link.download = 'Factura_' + numFactura + '.pdf'
									document.body.appendChild(link)
									link.click()
									document.body.removeChild(link)
								}
							}
						}
						reader.readAsText(response.data)
					}).catch(error => {
						console.error('Error al obtener PDF desde Netsuite:', error)
						alert('Error al obtener el PDF de la factura')
					})
				} else {
					this.url_factura = 'http://www.dimfactor.cl/facturacion/archivos/VENTAS/DTE/PDF/' + rutNCLeasing + '/' + anio + '/' + mes + '/DTE_' + rutNCLeasing + '_' + tipoDocumento + '_' + numFactura + '.pdf'
					window.open(this.url_factura, '_blank')
				}
				// }
			}
		},
		formatoNumero: function (valor, canDecimal, miles, decimal) {
			if (valor === null) {
				throw new TypeError('El valor no es valido')
			}
			if (!canDecimal) {
				var len = valor.toString().split('.').length
				canDecimal = len > 1 ? len : 0
			}
			if (!decimal) {
				decimal = ','
			}
			if (!miles) {
				miles = '.'
			}
			valor = parseFloat(valor).toFixed(canDecimal)
			valor = valor.replace('.', decimal)
			var splitNum = valor.split(decimal)
			splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles)
			valor = splitNum.join(decimal)
			return valor
		},
		countDecimals: function (value) {
			if (Math.floor(value) === value) return 0
			return value.toString().split('.')[1].length || 0
		},
		validateDniPeru (dni) {
			// Se separan los números de la letra
			let letraDNI = dni.substring(8, 9).toUpperCase()
			let numDNI = parseInt(dni.substring(0, 8))

			// Se calcula la letra correspondiente al número
			let letras = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E', 'T']
			let letraCorrecta = letras[numDNI % 23]

			if (letraDNI !== letraCorrecta) {
				// console.log("Has introducido una letra incorrecta\nTu letra debería ser: " + letraCorrecta);
				return false
			} else {
				// console.log("Enhorabuena hemos podido validar tu DNI");
				return true
			}
		},
		number_format (number, decimals, decpoint, thousandspoint) {
			number = number || 0
			if (!decimals) {
				var len = number.toString().split('.').length
				decimals = len > 1 ? len : 0
			}

			if (!decpoint) {
				decpoint = '.'
			}

			if (!thousandspoint) {
				thousandspoint = ','
			}

			number = parseFloat(number).toFixed(decimals)
			number = number.replace('.', decpoint)
			var splitNum = number.split(decpoint)
			splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandspoint)
			number = splitNum.join(decpoint)
			return number
		},
		dollar_format (number, decimals, decpoint, thousandspoint) {
			number = number || 0
			if (!decimals) {
				var len = number.toString().split('.').length
				decimals = len > 1 ? len : 0
			}

			if (!decpoint) {
				decpoint = ','
			}

			if (!thousandspoint) {
				thousandspoint = '.'
			}

			number = parseFloat(number).toFixed(decimals)
			number = number.replace('.', decpoint)
			var splitNum = number.split(decpoint)
			splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandspoint)
			number = splitNum.join(decpoint)
			return number
		},
		redirectIngresoCliente: function (index) {
			var params = btoa(index)
			var href = '/IngresoClientes?val=' + params
			window.open(href, '_blank')
		},
		redirectIngresoNegocio: function (index) {
			console.log('ruta=')
			var params = btoa(index)
			var href = '/IngresoNegocio?val=' + params
			window.open(href, '_blank')
		},
		redirectDetallePortafolio: function (index) {
			console.log('ruta=', index)
			var params = btoa(index)
			var href = '/Informes/DetallePortafolio?val=' + params
			window.open(href, '_blank')
		},
		descargaExcelGenerico: function (result) {
			const a = document.createElement('A')
			a.href = result.archivo
			a.setAttribute('download', `${result.nombre}.xlsx`)
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
		},
		descargaPdfGenerico: function (result) {
			const a = document.createElement('A')
			a.href = result.file
			a.setAttribute('download', `${result.name}.pdf`)
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
		},
		inArray (needle, haystack) {
			var length = haystack.length
			for (var i = 0; i < length; i++) {
				if (haystack[i] === needle) return true
			}
			return false
		},
		apiIndicadoresDiarios () {
			var currentDateWithFormat = new Date().toJSON().slice(0, 10)
			var res = currentDateWithFormat.split('-')
			this.axios.get('https://mindicador.cl/api/uf/' + res[2] + '-' + res[1] + '-' + res[0], {}).then(response => {
				this.valor_uf = response.data.serie[0].valor
			}).catch(error => {
				console.log(error.response.data)
			})
			this.axios.get('https://mindicador.cl/api/dolar/' + res[2] + '-' + res[1] + '-' + res[0], {}).then(response => {
				this.valor_dolar = response.data.serie[0].valor
			}).catch(error => {
				console.log(error.response.data)
			})
		},
		customFormatter (date) {
			return moment(date).format('YYYY-MM-DD')
		},
		validInputNumberDecimal (value) {
			value = value.toString()
			if (value === '.' || value === ',' ||
			(value.charAt(0) === '0' && value.charAt(1) !== '.' && value.length > 1) || // ej: 000
			(value.charAt(0) === '.' && value.length > 1) // ej: .02
			) {
				value = '0'
			}
			value = value.replace(/[^0-9.]/g, '')
			return value
		},
		fechaFormateada (date) {
			let year = date.getFullYear().toString()
			let month = (date.getMonth() + 1).toString()
			if (month.length === 1) {
				month = '0' + month
			}
			let day = date.getUTCDate().toString()
			if (day.length === 1) {
				day = '0' + day
			}
			return year + '-' + month + '-' + day
		},
		obtenerUrlFacturaDimFactor (nroFactura, fechaFacturacion) {
			if (nroFactura === null) {
				return null
			}
			let fechaFactura = fechaFacturacion.split('-')
			if (fechaFactura.length !== 3) {
				return null
			}
			let anio = fechaFactura[0]
			let mes = parseInt(fechaFactura[1])
			let rutNCLeasing = '76497459'
			return 'http://www.dimfactor.cl/facturacion/archivos/VENTAS/DTE/PDF/' + rutNCLeasing + '/' + anio + '/' + mes + '/DTE_' + rutNCLeasing + '_33_' + nroFactura + '.pdf'
		},
		validaRut (rutin) {
			if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutin)) {
				return false
			}
			var tmp 	= rutin.split('-')
			var digv	= tmp[1]
			var rut 	= tmp[0]
			if (digv === 'K') digv = 'k'
			if ($.trim(this.dv(rut)) === $.trim(digv)) {
				return true
			}

			return false
		},
		dv (T) {
			var M = 0; var S = 1
			for (;T; T = Math.floor(T / 10)) { S = (S + T % 10 * (9 - M++ % 6)) % 11 }
			return S ? S - 1 : 'k'
		},
		showModalGenerico (idModal, display) {
			if (display) {
				window.$('#' + idModal).fadeIn()
			} else {
				window.$('#' + idModal).fadeOut()
			}
		},
		validaPermiso (p) {
			let ret = false
			this.$store.state.accessPermisos.forEach((row, key) => {
				if (row.permiso === p) {
					ret = true
				}
			})
			return ret
		},
		formatNum (value, countDecimal = -1, sepMiles = '.', sepDecimal = ',') {
			if (/* value < 0 || */value === 0 || value == null || value === '') {
				return 0
			}
			let val = parseFloat(value)
			if (countDecimal !== -1) {
				val = val.toFixed(countDecimal)
			}

			var splitNum = val.toString().split('.')
			let soloMiles = splitNum[0]
			let soloDecimal = (splitNum[1]) ? splitNum[1] : ''

			soloMiles = soloMiles.replace(/\B(?=(\d{3})+(?!\d))/g, sepMiles)

			let valFinal = soloMiles + ((soloDecimal !== '') ? (sepDecimal + soloDecimal) : '')

			return valFinal
		},
		sum (array, campo, format = false, sepMiles = '.', sepDecimal = ',', cantDecimal = 2) {
			let total = 0
			let campoPartes = campo.split('|')
			array.forEach((val, k) => {
				campoPartes.forEach((c, k) => {
					if (val[c]) {
						let v = parseFloat(val[c])// parseFloat(parseFloat(val[c]).toFixed(2))
						total = total + v
					}
				})
			})
			if (format) {
				return this.formatNum(total, cantDecimal, sepMiles, sepDecimal)
			} else {
				return total
			}
		},
		convertirHoraLocal (horaChile, IdPais) {
			if (!horaChile) return ''
			try {
				const zonaOrigen = 'America/Santiago'
				let zonaDestino = ''

				switch (IdPais) {
				case 1: zonaDestino = 'America/Santiago'; break
				case 3: zonaDestino = 'America/Lima'; break
				case 4: zonaDestino = 'America/Bogota'; break
				default: zonaDestino = 'UTC'
				}
				// Usa fromFormat con el formato de tu fecha
				return DateTime.fromFormat(horaChile, 'yyyy-MM-dd HH:mm:ss.SSS', { zone: zonaOrigen })
					.setZone(zonaDestino)
					.toFormat('dd/MM/yyyy HH:mm')
			} catch (e) {
				console.warn('Hora no válida:', horaChile)
				return ''
			}
		}
	}
})



// WEBPACK FOOTER //
// ./src/main.js